import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import PeopleIcon from '@mui/icons-material/People';
import Map from '@mui/icons-material/Map';
import {Web, CalendarToday, Image, PeopleOutline, Book} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {useCan} from "../components/UserState/useCan";

export const MainListItems = () => {
  const {t} = useTranslation();
  const canPages = useCan('manage_pages');
  const canEvents = useCan('manage_events');
  const canCourses = useCan('manage_courses');
  const canLibrary = useCan('manage_library');
  const canUsers = useCan('manage_users');
  const canContacts = useCan('manage_contacts');

  return (
    <div>
      {canPages && (
        <ListItem button component={Link} to="/admin/pages">
            <ListItemIcon>
              <Web/>
            </ListItemIcon>
            <ListItemText primary={t('admin.sections.Pages')}/>
        </ListItem>
      )}
      {canEvents && (
        <ListItem button component={Link} to="/admin/events">
          <ListItemIcon>
            <CalendarToday/>
          </ListItemIcon>
          <ListItemText primary={t('admin.sections.Events')}/>
        </ListItem>
      )}
      {canCourses && (
        <ListItem button component={Link} to="/admin/courses">
          <ListItemIcon>
            <CalendarToday/>
          </ListItemIcon>
          <ListItemText primary={t('admin.sections.Courses')}/>
        </ListItem>
      )}
      {canLibrary && (
        <ListItem button component={Link} to="/admin/library">
            <ListItemIcon>
                <Book/>
            </ListItemIcon>
            <ListItemText primary={t('admin.sections.Library')}/>
        </ListItem>
      )}
      {canUsers && (
        <ListItem button component={Link} to="/admin/users">
          <ListItemIcon>
            <PeopleIcon/>
          </ListItemIcon>
          <ListItemText primary={t('admin.sections.Users')}/>
        </ListItem>
      )}
      {canPages && (
        <ListItem button component={Link} to="/admin/sidebar-images">
          <ListItemIcon>
            <Image/>
          </ListItemIcon>
          <ListItemText primary={t('admin.sections.SidebarImages')}/>
        </ListItem>
      )}
      {canContacts && (
        <ListItem button component={Link} to="/admin/guests">
          <ListItemIcon>
            <PeopleOutline/>
          </ListItemIcon>
          <ListItemText primary={t('admin.sections.Guests')}/>
        </ListItem >
      )}
    </div>
  );
}

export const SecondaryListItems = () => {
  const {t} = useTranslation();
  const canAdmin = useCan('admin');

  if (!canAdmin) return null;

  return (
    <div>
      <ListSubheader inset>{t('admin.sections.Other')}</ListSubheader>
      <ListItem button>
        <ListItemIcon>
          <Map/>
        </ListItemIcon>
        <ListItemText primary={t('admin.sections.Regions')}/>
      </ListItem>
    </div>
  )
};
